/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
  OnInit
} from '@angular/core';
import { ActionModel } from '@typescript-kit/view';

import { TimeRecordingSidebarModel } from '../../component-model/time-recording-sidebar.component-model';

@Component({
  selector: 'app-time-recording-sidebar',
  templateUrl: './time-recording-sidebar.component.html',
  styleUrls: ['./time-recording-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeRecordingSidebarComponent implements OnInit {
  public summaryHeaderToggle: ActionModel;
  public workingHoursHeaderToggle: ActionModel;

  @Input()
  public model: TimeRecordingSidebarModel;

  ngOnInit(): void {
    this.summaryHeaderToggle = new ActionModel({
      tags: { 'expanded': this.model.summaryExpanded },
      content: this.model.summaryHeader,
      onClick: (_, model: ActionModel) => {
        this.model.summaryExpanded = !this.model.summaryExpanded;
        model.tags.set('expanded', this.model.summaryExpanded);
      }
    });
    this.workingHoursHeaderToggle = new ActionModel({
      tags: { 'expanded': this.model.summaryExpanded },
      content: this.model.workingHoursHeader,
      onClick: (_, model: ActionModel) => {
        this.model.workingHoursExpanded = !this.model.workingHoursExpanded;
        model.tags.set('expanded', this.model.workingHoursExpanded);
      }
    });
  }
}
